<template>
	<div>
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/pop/pm/pm.jpg" class="steps step1" v-if="status==1">
         <div class="stepbtn" @click="nextStep(status)">
				{{status==1?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
		<breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'排名'}]"/>
		<div class="h-content">
			<div class="h-piece">
				<div class="h-formBox">
					<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder k-formBorder">
						<el-form-item label="销售经理">
							<el-input style="width:2rem" v-model="q.userNameLike" placeholder="请输入销售经理名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="所属区域">
							<brselect style="width:2rem" category="YLRegion" :v="q.areaCodeLike" v-model="q.areaCodeLike" clearable
								placeholder="--请选择--"></brselect>
						</el-form-item>
						<el-form-item class="h-formBtnOut">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
						</el-form-item>
						<el-form-item style="margin-left: 0.3rem;">
							<span class="h-formBoxTxt">我的评分：<span>{{myRank}}</span></span>
							<!-- <div class="h-tab2">
								<ul>
									<li  v-for="(item,index) in list" :key="index" @click="tabIndex(index)">
										<a :class="{'h-active':index==indx}">{{item}}</a>
									</li>
								</ul>
							</div> -->
						</el-form-item>
						<el-form-item class="nianboxs">
							<el-select v-model="labels" placeholder="请选择类型" @change="changestyle">
							    <el-option
							      v-for="item in options"
							      :key="item.value"
							      :label="item.label"
							      :value="item.value"
								  >
							    </el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="nianboxs" v-if="check1">
							   <el-date-picker
								v-model="value1"
								type="year"
								:clearable="false"
								@change="changyear"
								value-format="yyyy"
								placeholder="选择年">
							  </el-date-picker>
							  <!-- <img src="../../assets" alt=""> -->
						</el-form-item>
						<el-form-item class="nianboxs" v-if="check2">
							   <el-date-picker
								v-model="value2"
								:clearable="false"
								type="month"
								@change="changmonth"
								value-format="yyyy-MM"
								placeholder="选择月">
							  </el-date-picker>
						</el-form-item>
						<el-form-item class="nianboxs" v-if="check3">
							   <el-date-picker
							   id="getWeek"
							   ref="getWeek"
								v-model="value3"
								:clearable="false"
								type="week"
								@change="changweek"
								format="yyyy 第 WW 周"
								:picker-options="{
									firstDayOfWeek: 1
								}"
								placeholder="选择周">
							  </el-date-picker>
						</el-form-item>
						<el-form-item class="nianboxs" v-if="check4">
							   <el-date-picker
								v-model="value4"
								:clearable="false"
								type="date"
								value-format="yyyy-MM-dd"
								@change="changdate"
								placeholder="选择日">
							  </el-date-picker>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="h-piece h-borderT" style="padding-bottom: 0;">
				<div class="h-rankingList">
					<ul class="w-ul-content">
						<!-- <li  v-for="(item) in tableData" :key="item.id" :class="{'firstPai': (item.orderNo==1) ,'secondPai': (item.orderNo==2) , 'thirdPai':(item.orderNo==3)}" > -->
							<li  v-for="(item) in tableData" :key="item.id" >
							<a>
								<div class="h-rlImg">
									<!-- <i v-if="item.photoFile"><img :src= "item.photoFile.saveurl"></i>
									<i v-if="!item.photoFile"><img src="../../assets/images/haier.jpg"></i> -->
									<i style="border: 0;width: 1.1rem;height: 1.1rem;"><img src="../../assets/images/haier.jpg"></i>
								</div>
								<!-- <span class="h-rlNum">{{item.orderNo}}</span> -->
								<span class="h-rlNum"></span>
								<p class="h-rlName">{{item.userName}}</p>
								<label class="h-rlLabel">{{item.areaName}}</label>
								<p class="h-rlGrade">得分<span>{{item.adjScore}}</span></p>
							</a>
						</li>
					</ul>
				</div>
				
			</div>
			<button v-auth="'pubadm'" type="button" @click="publicPH" class="el-button h-btn h-formBtn h-bgblueQ el-button--default" style="text-align: center;margin-top: 0.2rem;"><!----><i class="h-el-icon h-el-icon-edit"></i><span>发布排行</span></button>
			<div class="h-pagination2 h-pageCenter" style="margin-top: 0.2rem;">
				<pagination :page="q" @query="query" />
			</div>
		</div>
	</div>
</template>

<script>
	import ss from '../../api/SystemService'
export default {
	data(){
      return{
			showOrhide:false,
			status:1,
			toshow:"paiming",
			checked:true,
			labels:'',
			options:[
			  {
				  value:'0',
				  label:'年榜'
			  },
			  {
				  value:'1',
				  label:'月榜'
			  },
			  {
				  value:'2',
				  label:'周榜'
			  },
			  {
				  value:'3',
				  label:'日榜'
			  }
		  ],
		  value1:'',
		  value2:'',
		  value3:'',
		  value4:'',
		  weeks:'',
		  check1:false,
		  check2:false,
		  check3:false,
		  check4:false,
		//表单
		q: {
			orderType:0,
			pageSize:10,
			pageNo:1,
			total:0,
		},
		tableData: [],
		//全选
		checkedCities:[],
		//切换
		indx:0,
		list:['年榜','月榜','周榜','日榜'],
		myRank:0,
      }
	},
	created() {
		this.showzhezhao()
		this.query();
	},
	methods:{
		showzhezhao(){
			ss.salesList.toshow(this.toshow).then(rd => {
				console.log(rd)
			    if(rd == false){
			        this.showOrhide = false;
			    }else{
			        this.showOrhide = true;
			    }
			})
		},
		publicPH(){
			ss.UserCare.rankingP(this.q).then(rd=>{
				console.log(rd.pub);
			})
		},
		// 通过周获取yyyy-MM-dd
		convertWeekNumberToFirstDate(sYear, sWeek, startFromFirstMonday)
		{
			if (startFromFirstMonday == undefined) startFromFirstMonday = true;
			var weekIndex = 1;
			var year = parseInt(sYear);
			var week = parseInt(sWeek);
			var i = 1;
			var dFirstDate = new Date(year, 0, i);
			if(!startFromFirstMonday){
				if (weekIndex < week){
					weekIndex++;
				}else
					return dFirstDate;
			}
			if(dFirstDate.getDay() != 1){
				i += 7 - dFirstDate.getDay() + 1;
				dFirstDate.setFullYear(year, 0, i);
		   }
		   if (weekIndex < week){
				i += 7*(week-weekIndex);
				dFirstDate.setFullYear(year, 0, i);
		   }
		   return dFirstDate;
		},
		// 通过yyyy-MM-dd转化成时间戳
		datetime_to_unix(datetime){
			var tmp_datetime = datetime.replace(/:/g,'-');
			tmp_datetime = tmp_datetime.replace(/ /g,'-');
			var arr = tmp_datetime.split("-");
			var now = new Date(Date.UTC(arr[0],arr[1]-1,arr[2],arr[3]-8,arr[4],arr[5]));
			return parseInt(now.getTime());
		},
		// 通过标准时间获取周
		getYearWeek(date) {
			date = new Date(date);
			var date2 = new Date(date.getFullYear(), 0, 1);
			var day1 = date.getDay();
			if (day1 == 0) day1 = 7;
			var day2 = date2.getDay();
			if (day2 == 0) day2 = 7;
			var d = Math.round((date.getTime() - date2.getTime() + (day2 - day1) * (24 * 60 * 60 * 1000)) / 86400000);
			return Math.ceil(d / 7) + 1;
		},
		// 切换类型
		changestyle(v){
			console.log(v)
			this.q.orderType= v;
			this.query()
			this.changetj(v)
		},
		changetj(v){
			if(v == 0){
				// 年榜
				this.q.orderDate= '';
				this.check1 = true;
				this.check2 = false;
				this.check3 = false;
				this.check4 = false;
			}else if(v==1){
				// 月榜
				this.q.orderDate= '';
				this.check2 = true;
				this.check1 = false;
				this.check3 = false;
				this.check4 = false;
			}else if(v==2){
				// 周榜
				this.q.orderDate= '';
				this.check3 = true;
				this.check1 = false;
				this.check2 = false;
				this.check4 = false;
			}else if(v==3){
				// 日榜
				this.q.orderDate= '';
				this.check4= true;
				this.check1 = false;
				this.check2 = false;
				this.check3 = false;
			}
		},
		// 选择年榜
		changyear(v){
			console.log(v)
			this.value2 = '';
			this.value3 = '';
			this.value4 = '';
			this.q.orderType= 0;
			this.q.orderDate= v;
			this.query()
		},
		// 选择月榜
		changmonth(v){
			console.log(v)
			this.value1 = '';
			this.value3 = '';
			this.value4 = '';
			this.q.orderType= 1;
			this.q.orderDate= v;
			this.query()
		},
		// 选择周榜
		changweek(v){
			console.log(v)
			this.weeks =v.getFullYear() + (this.getYearWeek(v)+'');
			console.log(this.weeks)
			this.value1 = '';
			this.value2 = '';
			this.value4 = '';
			this.q.orderType= 2;
			this.q.orderDate= this.weeks;
			this.query()
		},
		// 选择日榜
		changdate(v){
			console.log(v)
			this.value1 = '';
			this.value2 = '';
			this.value3 = '';
			this.q.orderType= 3;
			this.q.orderDate= v;
			this.query()
		},
		tabIndex(i){
			this.indx = i;
			this.q.orderType=i;
			console.log(this.indx);
			console.log(this.q.chartAll);
			this.query();
		},
		//表格
		handleSelectionChange(val) {
			this.multipleSelection = val;
		  },
		query() {
			ss.UserCare.ranking(this.q).then(rd=>{
				console.log(rd,"排名列表");
				this.q.total = rd.page.total;
				this.tableData = rd.page.records;
				this.tableData.forEach(elements=>{
					if(elements.photoFile){
						ss.UserCare.imgDown(elements.photoFile.id).then(data=>{
							var imgbase = 'data:image/png;base64,' + btoa(new Uint8Array(data.data).reduce((data, byte) => data + String.fromCharCode(
									byte), ''));
							if(imgbase!='data:image/png;base64'){
								elements.photoFile.saveurl = imgbase;
							}
						})
					}
				})
				if(!rd.myRank){
					this.myRank="暂无"
				}else{
					this.myRank=rd.myRank;
				}
				if(rd.rank){
                    this.labels=rd.rank.orderType;
                    this.changetj(this.labels);
	                if(this.labels==0){
	                    this.value1=rd.rank.orderDate;
	                }else if(this.labels==1){
	                    this.value2=rd.rank.orderDate;
	                }else if(this.labels==2){
						var year = rd.rank.orderDate.substr(0,4)
						var week = rd.rank.orderDate.substr(4,2)
						var dFirstDate = this.convertWeekNumberToFirstDate(year, week,false);
						console.log(dFirstDate)
						var sss = dFirstDate.getFullYear()+"-"+(dFirstDate.getMonth()+1)+"-"+dFirstDate.getDate();
						console.log(sss)
						var times = this.datetime_to_unix(sss + " 00:00:00");
						console.log(times)
						var time = this.$util.riQi(times) + " 00:00:00";
						console.log(time)
						time = time.replace(/-/g,':').replace(' ',':');
						time = time.split(':');
						var time1 = new Date(time[0],(time[1]-1),time[2],time[3],time[4],time[5]);
	                    this.value3=time1;
	                }else if(this.labels==3){
	                    this.value4=rd.rank.orderDate;
	                }
				}
            })
        },
		handleFilter() {
         this.query();
		},
		reset(){
			this.q= {
				orderType:this.q.orderType,
				pageSize:10,
				pageNo:1,
				total:0,
			}
		},
		// 关闭新手引导页
		closeIt(){
			this.showOrhide = false;
			if(this.checked){
				ss.salesList.toshow(this.toshow,this.checked).then(rd => {
					console.log(rd)
					this.showOrhide = false;
				})
			}else{
				ss.salesList.toshow(this.toshow,this.checked).then(rd => {
					console.log(rd)
					this.showOrhide = false;
				})
			}
		},
		nextStep(i){
			if(this.status ==1){
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
			}
		},
	},
	mounted(){

	},
}
</script>
<style>
	.nianboxs .el-form-item__content .el-date-editor{
		width: 1.7rem;
	}
	.nianboxs .el-form-item__content .el-input{
		width: 1.7rem;
	}
	.k-formBorder .el-form-item {
		margin-bottom: 0 !important;
	}
	.h-formBorder .nianboxs .el-input__inner{
		text-align: center;
		border-color: #59b0ff;
		color: #59b0ff;
	}
	.h-formBorder .nianboxs .el-input__icon{
		color: #59b0ff;
	}
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 0;
			left: 0;
			
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>
